import { RecommendRecipe } from "./RecommendRecipe";
export default RecommendRecipe;
